import { CONVENTIONAL, DOWNTILT_PREVIEW_DIMENSIONS } from 'helpers/globals'
import toRadian from 'helpers/toRadian'

export const computeDistanceToBlindSpot = (tilt, angle, cameraHeight) =>
  Math.tan(toRadian(90 + parseInt(tilt) - angle)) * parseInt(cameraHeight)

export const computeHeightBound = distance => Math.round((DOWNTILT_PREVIEW_DIMENSIONS.height / DOWNTILT_PREVIEW_DIMENSIONS.width) * distance)

export const cameraHeightGreaterThanComputed = (cameraHeight, distance) => cameraHeight >= computeHeightBound(distance)

export const computeDistanceDisplay = (cameraHeight, distance) =>
  cameraHeightGreaterThanComputed(cameraHeight, distance)
    ? Math.round((DOWNTILT_PREVIEW_DIMENSIONS.width / DOWNTILT_PREVIEW_DIMENSIONS.height) * cameraHeight)
    : Math.round(distance)

export const computeAngle = (fovMode, verticalAngleOfView, horizontalAngleOfView) =>
  fovMode === CONVENTIONAL ? verticalAngleOfView : horizontalAngleOfView

const computeHeightDisplay = (cameraHeight, distance, computedHeightBound) =>
  cameraHeightGreaterThanComputed(cameraHeight, distance) ? Math.round(cameraHeight) : computedHeightBound

export const computeCameraPxHeight = (cameraHeight, distance, computedHeightBound) =>
  (cameraHeight / computeHeightDisplay(cameraHeight, distance, computedHeightBound)) * DOWNTILT_PREVIEW_DIMENSIONS.height

export const computeSceneHeightLabelHeight = (sceneHeight, cameraHeight, distance, computedHeightBound) =>
  (sceneHeight / computeHeightDisplay(cameraHeight, distance, computedHeightBound)) * DOWNTILT_PREVIEW_DIMENSIONS.height



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/helpers/index.js